"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationProvider = void 0;
var axios_1 = __importDefault(require("axios"));
var BringgDashboardSDK_1 = require("../BringgDashboardSDK");
var URLEndpoint_1 = __importDefault(require("./Http/URLEndpoint"));
var Logger_1 = __importDefault(require("./Logger"));
var ConfigurationProvider = /** @class */ (function () {
    function ConfigurationProvider(_a) {
        var config = _a.config, fallbackConfig = _a.fallbackConfig, isLoadedFromEndpoint = _a.isLoadedFromEndpoint, commonRegionConfigKeys = _a.commonRegionConfigKeys, specificRegionConfigkeys = _a.specificRegionConfigkeys, _b = _a.clientId, clientId = _b === void 0 ? 'Bringg Dashboard' : _b;
        this.clientId = clientId;
        this.isLoadedFromEndpoint = isLoadedFromEndpoint;
        this.commonRegionConfigKeys = commonRegionConfigKeys;
        this.specificRegionConfigkeys = specificRegionConfigkeys;
        this.config = this.enrichConfig({ config: config, fallbackConfig: fallbackConfig, commonRegionConfigKeys: commonRegionConfigKeys, specificRegionConfigkeys: specificRegionConfigkeys });
    }
    ConfigurationProvider.prototype.enrichConfig = function (_a) {
        var config = _a.config, fallbackConfig = _a.fallbackConfig, commonRegionConfigKeys = _a.commonRegionConfigKeys, specificRegionConfigkeys = _a.specificRegionConfigkeys;
        if (!fallbackConfig && !commonRegionConfigKeys && !specificRegionConfigkeys) {
            return config;
        }
        var newConfig = {};
        if (fallbackConfig) {
            newConfig = __assign({}, fallbackConfig);
            if (config.default_region) {
                newConfig['default_region'] = config.default_region;
            }
        }
        else {
            newConfig = __assign({}, config);
        }
        var newRegions = {};
        for (var regionName in config.regions) {
            var specificRegionConfigkeysToMerge = specificRegionConfigkeys === null || specificRegionConfigkeys === void 0 ? void 0 : specificRegionConfigkeys[regionName];
            newRegions[regionName] = __assign(__assign(__assign({}, config.regions[regionName]), commonRegionConfigKeys), specificRegionConfigkeysToMerge);
        }
        newConfig['regions'] = newRegions;
        return newConfig;
    };
    ConfigurationProvider.fromUrl = function (_a) {
        var urlReceived = _a.urlReceived, fallbackConfig = _a.fallbackConfig, commonRegionConfigKeys = _a.commonRegionConfigKeys, specificRegionConfigkeys = _a.specificRegionConfigkeys, clientId = _a.clientId;
        return __awaiter(this, void 0, void 0, function () {
            var url, fetchedConfig, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = urlReceived instanceof URLEndpoint_1.default ? urlReceived.encode() : urlReceived;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api(url)];
                    case 2:
                        fetchedConfig = _b.sent();
                        return [2 /*return*/, new ConfigurationProvider({
                                config: fetchedConfig,
                                fallbackConfig: fallbackConfig,
                                commonRegionConfigKeys: commonRegionConfigKeys,
                                specificRegionConfigkeys: specificRegionConfigkeys,
                                isLoadedFromEndpoint: true,
                                clientId: clientId
                            })];
                    case 3:
                        e_1 = _b.sent();
                        Logger_1.default.error("can't initialise configuration from ".concat(url));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ConfigurationProvider.fromJson = function (_a) {
        var jsonConfig = _a.jsonConfig, fallbackConfig = _a.fallbackConfig, commonRegionConfigKeys = _a.commonRegionConfigKeys, specificRegionConfigkeys = _a.specificRegionConfigkeys, clientId = _a.clientId;
        return new ConfigurationProvider({
            config: JSON.parse(jsonConfig),
            fallbackConfig: fallbackConfig,
            commonRegionConfigKeys: commonRegionConfigKeys,
            specificRegionConfigkeys: specificRegionConfigkeys,
            clientId: clientId
        });
    };
    ConfigurationProvider.getNextRegion = function (region) {
        var regions = (0, BringgDashboardSDK_1.getConfigurationProvider)().getRegions();
        var currentRegionIndex = regions.indexOf(region);
        if (regions.length - 1 === currentRegionIndex) {
            return regions[0];
        }
        else {
            return regions[currentRegionIndex + 1];
        }
    };
    ConfigurationProvider.prototype.getApiEndpoint = function (region) {
        var _a, _b;
        return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.regions[region]) === null || _b === void 0 ? void 0 : _b.web_api_url;
    };
    ConfigurationProvider.prototype.getRegionDiscoveryEndpoint = function () {
        var _a, _b;
        return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.regions[this.getDefaultRegion()]) === null || _b === void 0 ? void 0 : _b.web_api_url;
    };
    ConfigurationProvider.prototype.getAuthenticationEndpoint = function (region) {
        var _a, _b;
        return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.regions[region]) === null || _b === void 0 ? void 0 : _b.web_api_url;
    };
    ConfigurationProvider.prototype.getMonitoringEndpoint = function (region) {
        var _a, _b, _c, _d;
        var realTimeUrl = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.regions[region]) === null || _b === void 0 ? void 0 : _b.real_time_url;
        var socketPort = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.regions[region]) === null || _d === void 0 ? void 0 : _d.socket_websocket_port;
        if (socketPort) {
            realTimeUrl += ':' + socketPort;
        }
        return realTimeUrl;
    };
    ConfigurationProvider.prototype.getGeneralEnvApiEndpoint = function () {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.general_env_api_url;
    };
    ConfigurationProvider.prototype.getDefaultRegion = function () {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.default_region;
    };
    ConfigurationProvider.prototype.getRegions = function () {
        return Object.keys(this.config.regions);
    };
    ConfigurationProvider.prototype.getClientId = function () {
        return this.clientId;
    };
    ConfigurationProvider.prototype.isUserAnalyticsEnabled = function () {
        var _a, _b;
        return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.user_analytics) === null || _b === void 0 ? void 0 : _b.enabled;
    };
    ConfigurationProvider.prototype.getUserAnalyticsApiKey = function () {
        var _a, _b;
        return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.user_analytics) === null || _b === void 0 ? void 0 : _b.api_key;
    };
    ConfigurationProvider.prototype.getCommonRegionConfigKeys = function () {
        return this.commonRegionConfigKeys;
    };
    ConfigurationProvider.prototype.getRegionSpecificConfigKeys = function () {
        return this.specificRegionConfigkeys;
    };
    ConfigurationProvider.prototype.getFullConfig = function () {
        return this.config;
    };
    ConfigurationProvider.getConfigUrl = function (env) { return "https://consts.bringg.com/regions/".concat(env, ".json"); };
    return ConfigurationProvider;
}());
exports.ConfigurationProvider = ConfigurationProvider;
function api(url) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default.get(url)];
                case 1:
                    response = _a.sent();
                    if (response.status >= 400) {
                        throw new Error(response.statusText);
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
}
//# sourceMappingURL=ConfigurationProvider.js.map